(function () {

function emoji () {}
// settings
emoji.img_path = 'emoji/';
emoji.img_suffix = '';
emoji.colon_aliases = {};
emoji.text_maps = {};
emoji.unified_blacklist = {};
emoji.non_native = {};

emoji.use_css_imgs = false;
emoji.colons_mode = false;
emoji.text_mode = false;
emoji.include_title = false;
emoji.allow_native = true;
emoji.use_sheet = false;
emoji.with_emocodes = true;

emoji.inits = {};
emoji.map = {};
emoji.categories = [
    "Smileys & Emotion",
    "People & Body",
    "Animals & Nature",
    "Food & Drink",
    "Travel & Places",
    "Activities",
    "Objects",
    "Symbols",
    "Flags"
];

emoji.re = {
    colons: /(:[^\s:]+:)(:skin-tone-[2-6]:)?/,
    strip_colons: /^:(:?[^:]+)(::skin-tone-[2-6])?:$/i,
    strip_colons_only: /^:(.+):$/i,
    multi_skin: /(\w+)-(\w+)/,
    ipv6_hex: /^[a-f0-9]+$/,
    ipv6_mask_pre: /([:*?]|(\b[a-f0-9:*?]+))$/,
    ipv6_mask_post: /^([:*?]|([a-f0-9:*?]+\b))/,
    ua_cr_os: /CrOS/i,
    ua_mac_os: /Mac OS X 1[01][_.][0-9]/i,
    ua_mac_os_hs: /Mac OS X 10[_.]13/i,
    ua_mac_os_mojave: /Mac OS X 10[_.]14/i,
    ua_mac_os_catalina: /Mac OS X 10[_.]15/i,
    ua_windows_10: /Windows NT 10\.\d/i
};

emoji.strip_colons = function (colon){
    return colon.replace(emoji.re.strip_colons, "$1");
};
emoji.strip_colons_only = function (colon){
    return colon.replace(emoji.re.strip_colons_only, "$1");
};
emoji.replace_colons = function(str, force_unified, skin_tone, options) {
    options = options || {};
    emoji.init_colons();
    var match = str.match(emoji.re.colons);
    if (!match) {
        return str;
    }
    var matchPart = match[0];
    var colon = match[1];
    var skin_colon = match[2];
    var idx = emoji.strip_colons(colon);
    var first = str.slice(0, match.index);
    var rest = str.slice(match.index+matchPart.length);
    var val = emoji.map.colons[idx];
    if (skin_colon) {
        var skin_idx = emoji.strip_colons(skin_colon);
        var skin_val = emoji.map.colons[skin_idx];
        if (skin_val) {
            skin_tone = emoji.data[skin_val][0][0];
        }
    }
    var replaced = ':' + idx;
    var colon_rest = ':' + rest;
    var was_replaced = false;

    if (
        // Filter out ipv6 hex masks
        // 1000:1000:100:1000:0
        // *:100:1000:0
        // ?:100:1000:0
        emoji.re.ipv6_hex.test(idx) && (
            (
                first &&
                first != ':' &&
                !/\s$/.test(first) && (
                    emoji.re.ipv6_mask_pre.test(first) ||
                    emoji.re.ipv6_mask_post.test(rest)
                )
            ) || (
                options.prev && (
                    emoji.re.ipv6_mask_pre.test(options.prev)
                )
            )
        )
    ) {
        rest = colon_rest;
    } else if (
        // Filter out Perl modules
        // Dpkg::package::package::package::package
        (!options.prev_replaced && /:$/.test(first))
    ) {
        rest = colon_rest;
    } else {
        if (val) {
            var titleText = idx;
            if (emoji.colon_aliases[val]) {
                var aliasIdx = _.indexOf(emoji.colon_aliases[val], idx);
                if (aliasIdx !== -1) {
                    var smileyAliasIdx = _.indexOf(emoji.colon_aliases[val], ':' + idx);
                    if (smileyAliasIdx !== -1) {
                        aliasIdx = smileyAliasIdx;
                    }
                    titleText = emoji.colon_aliases[val][aliasIdx];
                }
            }
            replaced = emoji.replacement(val, colon, titleText, colon, force_unified, skin_tone);
            was_replaced = true;
        } else if (idx in emoji.text_maps) {
            replaced = emoji.text_maps[idx];
        } else {
            rest = colon_rest;
        }
    }
    return first + replaced + emoji.replace_colons(rest, force_unified, undefined, {
        prev_replaced: was_replaced,
        prev: (options.prev || '') + first + replaced
    });
};
emoji.idx_to_title = function (idx) {
    if (emoji.data[idx]) return emoji.data[idx][3][0];
};
emoji.match_unified = function (str) {
    emoji.init_unified();
    return str.match(emoji.rx_unified);
};
emoji.unified_to_text = function (str) {
    var match = emoji.match_unified(str);
    if (match) {
        var first = str.slice(0, match.index);
        var m = match[1];
        var rest = match[3] + str.slice(match.index+match[0].length);
        var val = emoji.map.unified[m];
        var val_var = emoji.map.unified_vars[m];
        var replaced = m;
        if (val) {
            replaced = emoji.data[val][3][0];
            var skin_idx = emoji.skin_tone_to_idx(match[2]);
            if (skin_idx) {
                replaced += '::' + emoji.data[skin_idx][3][0];
            }
        } else if (val_var) {
            replaced = emoji.data[val_var[0]][3][0];
            replaced += '::' + emoji.data[val_var[1]][3][0];
        }
        return first + replaced + emoji.unified_to_text(rest);
    } else {
        return str;
    }
};
emoji.strip_unified = function (str, single) {
    var match = emoji.match_unified(str);
    if (match) {
        var first = str.slice(0, match.index);
        var rest = match[3] + str.slice(match.index+match[0].length);
        if (single) {
            return first + rest;
        } else {
            return first + emoji.strip_unified(rest);
        }
    } else {
        return str;
    }
};
emoji.replace_unified = function (str) {
    var match = emoji.match_unified(str);
    if (match) {
        var first = str.slice(0, match.index);
        var m = match[1];
        var rest = match[3] + str.slice(match.index+match[0].length);
        var val = emoji.map.unified[m];
        var val_var = emoji.map.unified_vars[m];
        var replaced = m;
        if (val) {
            replaced = emoji.replacement(val, m, emoji.idx_to_title(val), undefined, undefined, match[2]);
        } else if (val_var) {
            var skin_tone_idx = val_var[1];
            var skin_tone_data = emoji.data[skin_tone_idx];
            var skin_tone;
            if (skin_tone_data) {
                skin_tone = skin_tone_data[0][0];
            }
            replaced = emoji.replacement(val_var[0], m, emoji.idx_to_title(val_var[0]), undefined, undefined, skin_tone, skin_tone_idx);
        }
        return first + replaced + emoji.replace_unified(rest);
    } else {
        return str;
    }
};
emoji.make_attrs = function (attrs, extraClass) {
    if (attrs.classNames) {
        attrs.classNames = attrs.classNames.concat(extraClass);
        if (attrs.classNames.length) {
            attrs['class'] = attrs.classNames.join(' ');
        }
        delete attrs.classNames;
    }
    var parts = [];
    for (var attr in attrs) {
        if (attrs[attr] != null) {
            parts.push(attr + '="' + attrs[attr] + '"');
        }
    }
    return parts.length ? ' ' + parts.join(' ') : '';
};
emoji.wrap_span = function (val, attrs, extraClass) {
    extraClass = extraClass || [];
    return '<span'+emoji.make_attrs(attrs, extraClass)+'>' + val + '</span>';
};

emoji.skin_tone_to_idx = function (skin_tone) {
    return emoji.map.skin_tone_to_idx[skin_tone];
};
emoji.idx_to_colon = function (idx, skin_tone) {
    var out = ':'+emoji.data[idx][3][0]+':';
    var skin_idx = emoji.skin_tone_to_idx(skin_tone);
    if (skin_idx) {
        if (emoji.variations_data[idx] && emoji.variations_data[idx][skin_idx]) {
            out += ':'+emoji.data[skin_idx][3][0]+':';
        }
    }
    return out;
};

function get_version (idx) {
    return emoji.data[idx][6];
}
function get_variation_version (idx, skin_idx) {
    if (!skin_idx) {
        return get_version(idx);
    }
    if (!emoji.variations_data[idx]) {
        return;
    }
    return emoji.variations_data[idx][skin_idx][4];
}

emoji.check_allow_native = function (idx, skin_idx) {
    if (emoji.non_native[idx]) {
        return false;
    }
    if (
        emoji.allow_native &&
        emoji.replace_mode == 'unified' &&
        emoji.data[idx][0][0]
    ) {
        // Emoji 5.0 / Unicode 10.0 is ready from High Sierra and Windows 10 onwards
        if (
            get_variation_version(idx, skin_idx) === '5.0' &&
            !emoji.is_mac_os_hs() &&
            !emoji.is_mac_os_mojave() &&
            !emoji.is_mac_os_catalina() &&
            !emoji.is_mac_os_bigsur() &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_10() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 11 is ready from Mojave and Windows 10 onwards
        if (
            get_variation_version(idx, skin_idx) === '11.0' &&
            !emoji.is_mac_os_mojave() &&
            !emoji.is_mac_os_catalina() &&
            !emoji.is_mac_os_bigsur() &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_10() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 12.0 is ready from Catalina and Windows 10 onwards
        if (
            get_variation_version(idx, skin_idx) === '12.0' &&
            !emoji.is_mac_os_catalina() &&
            !emoji.is_mac_os_bigsur() &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_10() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 12.1 is ready from Catalina and Windows 11 onwards
        if (
            get_variation_version(idx, skin_idx) === '12.1' &&
            !emoji.is_mac_os_catalina() &&
            !emoji.is_mac_os_bigsur() &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 13.0 is ready from Big Sur and Windows 11 onwards
        if (
            get_variation_version(idx, skin_idx) === '13.0' &&
            !emoji.is_mac_os_bigsur() &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 13.1 is ready from Big Sur and Windows 11 onwards
        if (
            get_variation_version(idx, skin_idx) === '13.1' &&
            !emoji.is_mac_os_bigsur() &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 14.0 is ready from Monterey and Windows 11 onwards
        if (
            get_variation_version(idx, skin_idx) === '14.0' &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 15.0 is ready from Ventura and Windows 11 onwards
        if (
            get_variation_version(idx, skin_idx) === '15.0' &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 15.1 is ready from Sonoma and Windows 11 onwards
        if (
            get_variation_version(idx, skin_idx) === '15.1' &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }

        if (emoji.is_windows_10() || emoji.is_windows_11()) {
            // Windows doesn't support country flags
            if (
                emoji.data[idx][7] === 'country-flag' ||
                emoji.data[idx][7] === 'subdivision-flag'
            ) {
                return false;
            }
        }

        switch (idx) {
        // Mojave only
        case '1f1fa-1f1f3': // flag-un
            return emoji.is_mac_os_mojave() ||
                   emoji.is_mac_os_catalina() ||
                   emoji.is_mac_os_bigsur() ||
                   emoji.is_mac_os_monterey() ||
                   emoji.is_mac_os_ventura();
        // Windows only
        case '2695-fe0f': // medical_symbol
        case '2640-fe0f': // female_sign
        case '2642-fe0f': // male_sign
            return emoji.is_windows_10() ||
                   emoji.is_windows_11();
        }

        return true;
    }
    return false;
};
emoji.replacement = function(idx, actual, titleText, colon, force_unified, skin_tone, skin_idx) {
    skin_tone = skin_tone || '';
    skin_idx = skin_idx || emoji.skin_tone_to_idx(skin_tone);
    var full_idx = idx;
    var variation_data;
    if (skin_idx) {
        variation_data = emoji.variations_data[idx] && emoji.variations_data[idx][skin_idx];
        if (variation_data) {
            full_idx = variation_data[0];
        } else {
            skin_idx = '';
            skin_tone = '';
        }
    }

    if (force_unified) {
        if (variation_data) {
            return variation_data[3][0];
        } else {
            return emoji.data[idx][0][0] + skin_tone;
        }
    }
    if (emoji.colons_mode) {
        var out = ':'+emoji.data[idx][3][0]+':';
        if (skin_idx) {
            out += ':'+emoji.data[skin_idx][3][0]+':';
        }
        return out;
    }
    if (emoji.text_mode) {
        var text_name = ':' + titleText + ':';
        return text_name;
    }
    emoji.init_env();
    var attrs = {classNames: []};
    if (emoji.include_title) {
        attrs.title = titleText;
    }
    var extraClass = [];
    var emoCode = '';
    if (emoji.with_emocodes && colon) {
        emoCode = emoji.wrap_span(colon, {
            classNames: ['emocode']
        });
        extraClass.push('emoconverted');
    }

    if (emoji.check_allow_native(idx, skin_idx)) {
        extraClass.push('emojinative');
        if (emoji.is_windows_10()) {
            extraClass.push('emojinative--win');
        }
        if (emoji.is_cr_os_native()) {
            extraClass.push('emojinative--cros');
        }
        if (emoji.is_mac_os_native()) {
            extraClass.push('emojinative--mac');
        }
        var native;
        if (variation_data) {
            native = variation_data[3][0];
        } else {
            native = emoji.data[idx][0][0] + skin_tone;
        }

        return emoji.wrap_span(native, attrs, extraClass) + emoCode;
    }
    attrs.classNames.push('emoji');
    var img = emoji.img_path+idx+'.png' + emoji.img_suffix;
    if (emoji.supports_css) {
        var px = emoji.data[idx][4];
        var py = emoji.data[idx][5];
        if (variation_data) {
            px = variation_data[1];
            py = variation_data[2];
            img = emoji.img_path+full_idx+'.png' + emoji.img_suffix;
        }
        if (emoji.use_sheet && px != null && py != null) {
            var mul = 100 / (emoji.sheet_size - 1);
            attrs.style = 'background-position:'+(mul*px)+'% '+(mul*py)+'%;';
            return emoji.wrap_span(actual, attrs, extraClass) + emoCode;
        } else if (emoji.use_css_imgs){
            attrs.classNames.push('emoji-'+full_idx);
            return emoji.wrap_span(actual, attrs, extraClass) + emoCode;
        } else {
            attrs.classNames.push('emoji-sizer');
            attrs.style = 'background-image:url('+img+')';
            return emoji.wrap_span(actual, attrs, extraClass) + emoCode;
        }
    }
    attrs.src = img;
    return '<img' + emoji.make_attrs(attrs) + '>' + emoCode;
};
emoji.init_colons = function(){
    if (emoji.inits.colons) return;
    emoji.inits.colons = 1;
    emoji.map.colons = {};
    var names;
    for (var i in emoji.data){
        names = emoji.data[i][3];
        if (emoji.colon_aliases[i]) {
            names = names.concat(emoji.colon_aliases[i]);
        }
        for (var j=0; j<names.length; j++){
            emoji.map.colons[names[j].toLowerCase()] = i;
        }
    }
};
emoji.init_unified = function(){
    if (emoji.inits.unified) return;
    emoji.inits.unified = 1;

    var a = [];
    emoji.map.unified = {};
    emoji.map.unified_vars = {};
    emoji.map.category = {};
    emoji.map.skin_tone_to_idx = {};

    for (var i in emoji.data){
        if (!emoji.map.category[emoji.data[i][1]]) {
            emoji.map.category[emoji.data[i][1]] = [];
        }
        emoji.map.category[emoji.data[i][1]].push({key: i, item: emoji.data[i]});
        if (emoji.data[i][1] === 'Component' && emoji.data[i][7] === 'skin-tone') {
            emoji.map.skin_tone_to_idx[emoji.data[i][0][0]] = i;
        }

        var eCodes = emoji.data[i][0];
        for (var j = 0; j < eCodes.length; j++) {
            if (!emoji.unified_blacklist[eCodes[j]]) {
                a.push(eCodes[j].replace('*', '\\*'));
                emoji.map.unified[eCodes[j]] = i;
            }
        }
    }
    for (var vi in emoji.variations_data){
        var toAdd = [];
        var eVars = emoji.variations_data[vi];
        for (var vk in eVars) {
            var vCodes = eVars[vk][3];
            var multi_tone = vk.match(emoji.re.multi_skin);
            if (multi_tone && multi_tone[1] == multi_tone[2] && !emoji.variations_data[multi_tone[1]]) {
                toAdd.push([multi_tone[1], eVars[vk]]);
            }
            for (var vj = 0; vj < vCodes.length; vj++) {
                a.push(vCodes[vj].replace('*', '\\*'));
                emoji.map.unified_vars[vCodes[vj]] = [vi, vk];
            }
        }
        // Add simple form same skin tone variations when missing (e.g. people_holding_hands)
        if (toAdd.length) {
            for (var addI = 0; addI < toAdd.length; addI++) {
                eVars[toAdd[addI][0]] = toAdd[addI][1];
            }
        }
    }

    for (var cat in emoji.map.category) {
        emoji.map.category[cat].sort(function (a, b) {
            return a.item[2] - b.item[2];
        });
    }

    // Sort by length so that combined sequences match first
    a.sort(function (a, b) {
        return b.length - a.length;
    });
    // Escape code points, they get corrupted by uglify otherwise
    emoji.rx_unified = new RegExp('('+a.join('|')+')(\\uD83C[\\uDFFB-\\uDFFF])?([^\\ufe0e]|$)');
};
emoji.init_env = function(){
    if (emoji.inits.env) return;
    emoji.inits.env = 1;
    emoji.replace_mode = 'img';
    emoji.supports_css = false;
    if (window.getComputedStyle){
        var st = window.getComputedStyle(document.body);
        if (st['background-size'] || st['backgroundSize']){
            emoji.supports_css = true;
        }
    }
    if (emoji.supports_css) {
        emoji.replace_mode = 'css';
    }
    if (emoji.is_mac_os_native() || emoji.is_windows_10() || emoji.is_windows_11() || emoji.is_cr_os_native()) {
        emoji.replace_mode = 'unified';
    }
};

var _is_cr_os_native = null;
emoji.is_cr_os_native = function () {
    if (_is_cr_os_native === null) {
        _is_cr_os_native = emoji.re.ua_cr_os.test(navigator.userAgent);
    }
    return _is_cr_os_native;
};

var _is_mac_os_native = null;
emoji.is_mac_os_native = function () {
    if (_is_mac_os_native === null) {
        _is_mac_os_native = emoji.re.ua_mac_os.test(navigator.userAgent);
    }
    return _is_mac_os_native;
};

var _is_mac_os_hs = null;
emoji.is_mac_os_hs = function () {
    if (_is_mac_os_hs === null) {
        _is_mac_os_hs = emoji.re.ua_mac_os_hs.test(navigator.userAgent);
    }
    return _is_mac_os_hs;
};

var _is_mac_os_mojave = null;
emoji.is_mac_os_mojave = function () {
    if (_is_mac_os_mojave === null) {
        _is_mac_os_mojave = emoji.re.ua_mac_os_mojave.test(navigator.userAgent);
    }
    return _is_mac_os_mojave;
};

var _is_mac_os_catalina = null;
emoji.is_mac_os_catalina = function () {
    if (_is_mac_os_catalina === null) {
        _is_mac_os_catalina = emoji.re.ua_mac_os_catalina.test(navigator.userAgent);
    }
    return _is_mac_os_catalina;
};

function platform_test (platform, versions) {
    if ('userAgentData' in navigator) {
        return navigator.userAgentData.getHighEntropyValues(["platformVersion"]).then(function (ua) {
            if (ua.platform === platform) {
                return _.any(versions, function (version) {
                    return ua.platformVersion.indexOf(version) === 0;
                });
            }
            return false;
        });
    }
}

var _is_mac_os_bigsur = null;
emoji.is_mac_os_bigsur = function () {
    if (_is_mac_os_bigsur === null) {
        _is_mac_os_bigsur = false; // Fallback
        var prom = platform_test('macOS', ['11.']);
        if (prom) {
            prom.then(function (ret) {
                _is_mac_os_bigsur = ret;
            });
        }
    }
    return _is_mac_os_bigsur;
};

var _is_mac_os_monterey = null;
emoji.is_mac_os_monterey = function () {
    if (_is_mac_os_monterey === null) {
        _is_mac_os_monterey = false; // Fallback
        var prom = platform_test('macOS', ['12.']);
        if (prom) {
            prom.then(function (ret) {
                _is_mac_os_monterey = ret;
            });
        }
    }
    return _is_mac_os_monterey;
};

var _is_mac_os_ventura = null;
emoji.is_mac_os_ventura = function () {
    if (_is_mac_os_ventura === null) {
        _is_mac_os_ventura = false; // Fallback
        var prom = platform_test('macOS', ['13.']);
        if (prom) {
            prom.then(function (ret) {
                _is_mac_os_ventura = ret;
            });
        }
    }
    return _is_mac_os_ventura;
};

var _is_mac_os_sonoma = null;
emoji.is_mac_os_sonoma = function () {
    if (_is_mac_os_sonoma === null) {
        _is_mac_os_sonoma = false; // Fallback
        var prom = platform_test('macOS', ['14.']);
        if (prom) {
            prom.then(function (ret) {
                _is_mac_os_sonoma = ret;
            });
        }
    }
    return _is_mac_os_sonoma;
};

var _is_windows_10 = null;
emoji.is_windows_10 = function () {
    if (emoji.is_windows_11()) {
        return false;
    }
    if (_is_windows_10 === null) {
        _is_windows_10 = emoji.re.ua_windows_10.test(navigator.userAgent);
    }
    return _is_windows_10;
};

var _is_windows_11 = null;
emoji.is_windows_11 = function () {
    if (_is_windows_11 === null) {
        _is_windows_11 = false; // Fallback
        var prom = platform_test('Windows', ['13.', '14.', '15.']);
        if (prom) {
            prom.then(function (ret) {
                _is_windows_11 = ret;
            });
        }
    }
    return _is_windows_11;
};

// Prefetch promise based uas
emoji.is_mac_os_bigsur();
emoji.is_mac_os_monterey();
emoji.is_mac_os_ventura();
emoji.is_mac_os_sonoma();
emoji.is_windows_11();

window.emoji = emoji;

})();


//////////////////
// WEBPACK FOOTER
// ./app/lib/emoji.js
// module id = nEsx
// module chunks = 3